/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { SafeDepositBoxServiceAgreementProperties } from './SafeDepositBoxServiceAgreementProperties';
import {
    instanceOfSafeDepositBoxServiceAgreementProperties,
    SafeDepositBoxServiceAgreementPropertiesFromJSON,
    SafeDepositBoxServiceAgreementPropertiesFromJSONTyped,
    SafeDepositBoxServiceAgreementPropertiesToJSON,
} from './SafeDepositBoxServiceAgreementProperties';
import type { WealthPlanningServiceAgreementProperties } from './WealthPlanningServiceAgreementProperties';
import {
    instanceOfWealthPlanningServiceAgreementProperties,
    WealthPlanningServiceAgreementPropertiesFromJSON,
    WealthPlanningServiceAgreementPropertiesFromJSONTyped,
    WealthPlanningServiceAgreementPropertiesToJSON,
} from './WealthPlanningServiceAgreementProperties';

/**
 * @type ProductSpecificServiceAgreementProperties
 * 
 * @export
 */
export type ProductSpecificServiceAgreementProperties = { propertiesType: 'SAFE_DEPOSIT_BOX' } & SafeDepositBoxServiceAgreementProperties | { propertiesType: 'WEALTH_PLANNING' } & WealthPlanningServiceAgreementProperties;

export function ProductSpecificServiceAgreementPropertiesFromJSON(json: any): ProductSpecificServiceAgreementProperties {
    return ProductSpecificServiceAgreementPropertiesFromJSONTyped(json, false);
}

export function ProductSpecificServiceAgreementPropertiesFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductSpecificServiceAgreementProperties {
    if (json == null) {
        return json;
    }
    switch (json['propertiesType']) {
        case 'SAFE_DEPOSIT_BOX':
            return Object.assign({}, SafeDepositBoxServiceAgreementPropertiesFromJSONTyped(json, true), { propertiesType: 'SAFE_DEPOSIT_BOX' } as const);
        case 'WEALTH_PLANNING':
            return Object.assign({}, WealthPlanningServiceAgreementPropertiesFromJSONTyped(json, true), { propertiesType: 'WEALTH_PLANNING' } as const);
        default:
            return json;
    }
}

export function ProductSpecificServiceAgreementPropertiesToJSON(json: any): any {
    return ProductSpecificServiceAgreementPropertiesToJSONTyped(json, false);
}

export function ProductSpecificServiceAgreementPropertiesToJSONTyped(value?: ProductSpecificServiceAgreementProperties | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    switch (value['propertiesType']) {
        case 'SAFE_DEPOSIT_BOX':
            return Object.assign({}, SafeDepositBoxServiceAgreementPropertiesToJSON(value), { propertiesType: 'SAFE_DEPOSIT_BOX' } as const);
        case 'WEALTH_PLANNING':
            return Object.assign({}, WealthPlanningServiceAgreementPropertiesToJSON(value), { propertiesType: 'WEALTH_PLANNING' } as const);
        default:
            return value;
    }
}

